import { render, staticRenderFns } from "./DetalheProduto.vue?vue&type=template&id=7823eb27&scoped=true&"
import script from "./DetalheProduto.vue?vue&type=script&lang=js&"
export * from "./DetalheProduto.vue?vue&type=script&lang=js&"
import style0 from "./DetalheProduto.vue?vue&type=style&index=0&id=7823eb27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7823eb27",
  null
  
)

export default component.exports